module.exports = __webpack_public_path__ + "img/Flag_of_Wallis_and_Futuna.3afcf0e6.svg";